import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { fetchIndividualConsultation, createIndividualConsultationDocument } from './actions';
import { getChild } from '../reducer';
import PaymentView from './View';
import DocumentsList from './ParentDocumentsList';
import QuestionnaireUpload from './QuestionnaireUpload';
import FormsList from './ParentFormsList';
import BackButton from '../../common/components/BackButton';

class Details extends Component {
    constructor(props) {
        super(props);
        this.handleDocumentUpload = this.handleDocumentUpload.bind(this);
    }

    componentDidMount() {
        this.props.fetchIndividualConsultation(Number(this.props.match.params.id));
    }

    handleDocumentUpload(document) {
        const { payment, createIndividualConsultationDocument } = this.props;
        createIndividualConsultationDocument(payment.id, document);
    }

    render() {
        const { payment, questionnaireFormUrl, enableUserTimeZone, t } = this.props;

        return <div>
            {payment && <Row>
                <Col md={8}>
                    <FormsList paymentId={payment.id} forms={payment.forms} />
                    {payment.requiresQuestionnaire && questionnaireFormUrl && <QuestionnaireUpload questionnaireFormUrl={questionnaireFormUrl} onSubmit={this.handleDocumentUpload} />}
                    <DocumentsList documents={payment.documents} canAddDocuments={payment.canAttachDocuments} onAddDocument={this.handleDocumentUpload} />
                </Col>
                <Col md={4}>
                    <PaymentView payment={payment} enableUserTimeZone={enableUserTimeZone} />
                </Col>
            </Row>}
            <Row className='parent-dashboard-box'>
                <Col sm={12}>
                    <BackButton />
                </Col>
            </Row>
        </div>;
    }
}

const mapStateToProps = (state, ownProps) => {
    const paymentId = ownProps.match.params.id;

    const { parent, entities: { individualConsultations, centers }, configuration: { franchisor } } = state;

    const payment = individualConsultations[paymentId];
    if (payment) {
        payment.child = getChild(parent, payment.childId);

        if (payment.centerId) {
            payment.center = centers[payment.centerId];
        }
    }

    return {
        payment,
        questionnaireFormUrl: franchisor && franchisor.individualConsultationQuestionnaireUrl,
        enableUserTimeZone: franchisor && franchisor.enableUserTimeZone
    };
};

export default connect(mapStateToProps, {
    fetchIndividualConsultation,
    createIndividualConsultationDocument
})(withTranslation()(Details));